'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// ./~/_es-object-atoms@1.1.2@es-object-atoms/index.js
// module id = 495
// module chunks = 0